import gql from 'graphql-tag'

export const USUARIOS_TIPOS_ACESSOS_BY_TIPO = gql`
  query UsuariosTipoAcessoByTipo(
    $tipoUsuario: String!
    $dealerIds: [ID!]!
    $busca: String
  ) {
    usuariosByTipoUsuario(
      tipo: $tipoUsuario
      dealerIds: $dealerIds
      busca: $busca
    ) {
      id
      nome
      email
      tiposAcesso {
        id
        nome
        produto {
          id
          nome
        }
      }
      funcionalidades {
        id
        produto {
          id
        }
      }
    }
  }
`
